<template>
<div id="billing-hotel">
    <v-card flat class="pa-sm-3">
        <v-card-text>
            <v-row wrap>
                <v-col cols="12" md="6">
                    <div>
                        <div class="important">{{ $t('hotel.billing.profile') }}:
                            <span class="font-weight-bold my-1">{{ billing.name }}</span>
                        </div>
                        <div class="regular ml-3">{{ billing.fiscal_code }}</div>
                        <div class="regular ml-3">{{ billing.registry_number }}</div>
                        <div class="regular ml-3">
                            <span v-if="billing.address.street">, {{ billing.address.street }}</span>
                            <span v-if="billing.address.number">, {{ billing.address.number }}</span>
                            <span v-if="billing.address.building">, {{ billing.address.building }}</span>
                        </div>
                        <div class="regular ml-3">
                            {{ billing.address.city }}
                            <span v-if="billing.address.postal_code">, {{ billing.address.postal_code }}</span>
                        </div>
                        <div class="regular font-weight-medium ml-2 mt-2">
                            {{ $t('hotel.billing.bank') }}:
                        </div>
                        <div class="regular ml-3" v-for="(bank,index) in billing.banks" :key="index">
                            <div class>{{ bank.name }}</div>
                            <div class>{{ bank.account }} {{ bank.currency }}</div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</div>
</template>

<script>
import {
    mapActions
} from 'vuex';


export default {
    props: {
        item: Object,
    },
    name: `item-hotel`,
    data() {
        return {
            org_id: null,
            billing: {
                name: null,
                type: null,
                fiscal_code: null,
                registry_number: null,
                banks: [{
                    name: null,
                    account: null,
                    currency: null,
                }],
                contact: {
                    name: null,
                    email: null,
                    phone: null,
                    position: null,
                },
                address: {
                    country: null,
                    state: null,
                    city: null,
                    street: null,
                    number: null,
                    building: null,
                    postal_code: null,
                }
            },
        };
    },

    watch: {
        item: {
            handler() {
                this.getBillingDetail(this.item.org_id);
            }
        },
    },

    created() {
        this.getBillingDetail(this.item.org_id);
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        getBillingDetail(value) {

            if(!value) {
                return
            }
            // construct params object
            let params = {
                params: {
                    owner_ids: [value]
                }
            };
            // prepare endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/profiles/billings";

            this.$axios.get(endpoint, params)
                .then(response => {
                    if(response.data.data[0]) {
                        this.billing = response.data.data[0];
                    }
                })
                .catch(error => {
                    // logger.error(error.message, error.stack)
                    //     .then(() => null);
                    this.error("Oops, something went wrong!");
                    console.log(error);
                })
                .finally(() => {});
        },

    },

};
</script>
